import axios from "axios";

export const sendEmail = async (email: string) => {
  return axios.post("/api/send-email", { email });
};
